import { render, staticRenderFns } from "./simulationTri.vue?vue&type=template&id=2e47b537&scoped=true"
import script from "./simulationTri.vue?vue&type=script&lang=js"
export * from "./simulationTri.vue?vue&type=script&lang=js"
import style0 from "./simulationTri.vue?vue&type=style&index=0&id=2e47b537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e47b537",
  null
  
)

export default component.exports